import { notification } from "antd";
import { QueryClient } from "react-query";
import { errorMessage } from "../service/service";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
            onError: (e: any) => {
                notification.error({
                    message: "出错了",
                    description: errorMessage(e)
                });
            }
        },
        mutations: {
            onError: (e: any) => {
                notification.error({
                    message: "出错了",
                    description: errorMessage(e)
                });
            }
        }
    }
});
